<template>
  <div class="login-box">
    <div class="card card-outline card-primary" id="loading-container">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Enter new password</p>

        <form @submit.prevent="doUpdatePassword">
          <div class="form-group">
            <b-form-input
              id="password-input"
              name="password-input"
              v-model="newPassword"
              v-validate="{ required: true, min: 8, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])([a-zA-Z\d]|[^A-Za-z\d]){8,}$/ }"
              :state="validateState('password-input')"
              aria-describedby="password-input-live-feedback"
              autocomplete="off"
              data-vv-as="Password"
              placeholder="New Password"
              ref="password"
            />
            <b-form-invalid-feedback id="password-input-live-feedback">{{ veeErrors.first('password-input') }}. Password must contain a number, at least one special character, one capital and one lowercase letter.</b-form-invalid-feedback>
          </div>
          <div class="form-group">
            <b-form-input
              id="password-confirm-input"
              name="password-confirm-input"
              v-model="newPasswordConfirmation"
              v-validate="'required|confirmed:password'"
              :state="validateState('password-confirm-input')"
              aria-describedby="password-confirm-input-live-feedback"
              data-vv-as="Password"
              autocomplete="off"
              placeholder="Confrim New Password"
            />
            <b-form-invalid-feedback id="password-confirm-input-live-feedback">{{ veeErrors.first('password-confirm-input') }}</b-form-invalid-feedback>
          </div>
          <div class="row mb-3">
            <div class="col-md-12 col-sm-12">
              <button type="submit" class="btn btn-success btn-block">Update Password</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ResetPassword',
  components: {},
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    doUpdatePassword: function () {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });
      loadingInstance.show();

      this.$http({
        url: '/api/v1/users/update-password',
        data: {
          resetToken: this.$route.params.token,
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirmation,
        },
        method: 'POST'
      }).then(() => {
        this.password = this.newPassword;
        this.$toastr.s("Password successfully updated");
        this.$router.push('/login')
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.$toastr.e(error.response.data.message);
          return;
        }

        if (error.message) {
          this.$toastr.e(error.message);
        }
      }).finally(() => {
        loadingInstance.close();
      })
    },
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
    ]),
  },
  created() {
  },
  mounted () {
    this.appElement = document.getElementById('application');
    this.appElement.classList.add('hold-transition', 'login-page');
  },
  beforeDestroy() {
    this.appElement.classList.remove("hold-transition", "login-page");
  },
  data(){
    return {
      appElement: null,
      newPassword: '',
      newPasswordConfirmation: '',
      resetToken: null,

    }
  },
}
</script>
